import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import angular, {IModule, IPromise, IScope, IWindowService} from "angular";
import {l} from "../../../../../types/typescriptdefinisjoner_lederplan";
import {MalmøteRessurs} from "../../../../../felles/tjenester/ressurser/MalmøteRessurs";
import {Tidssonevalg} from "../../../../../felles/tjenester/i18n/Tidssonevalg";
import {MalsakskjemaKontroller} from "../../komponenter/malsakskjema/malsakskjema";
import {MalmøteTjeneste, MøtemalSkjemaModell} from "../../MalmøteTjeneste";
import _ from "lodash";
import {Dialog} from "../../../../tjenester/Dialog";
import {gettextCatalog} from "angular-gettext";

const css = require('./redigerMøtemalDialog.scss');

export class RedigerMøtemalDialog {

    static visRedigerMøtemalDialog(gruppe: l.EnkelEllerGruppeModellEller, $mdDialog: angular.material.IDialogService): IPromise<l.MalmøteModell> {
        return $mdDialog.show(this.dialogKonfigurasjon({gruppe: gruppe, forespurtTrinn: null}));
    }

    static visRedigerMøtemalDialogMedForepurtTrinn(gruppe: l.EnkelEllerGruppeModellEller, forespurtTrinn:RedigerMøtemalTrinn, $mdDialog: angular.material.IDialogService): IPromise<l.MalmøteModell> {
        return $mdDialog.show(this.dialogKonfigurasjon({gruppe: gruppe, forespurtTrinn: forespurtTrinn}));
    }

    private static dialogKonfigurasjon(locals: Object): angular.material.IDialogOptions {
        return {
            template: require('./redigerMøtemalDialog.html'),
            controller: RedigerMøtemalDialog.forInjisering(),
            controllerAs: '$ctrl',
            bindToController: true,
            locals: locals,
            multiple: true //for å tillatte at denne dialogen vises samtidig som opprett-møte-dialogen (når man klikker på rediger-møtemal i opprett-møte-dialogen)
        };
    }

    static forInjisering() {
        return [
            regNavn.md.$mdDialog,
            regNavn.ng.$scope,
            regNavn.ng.$window,
            MalmøteRessurs.regNavn,
            Tidssonevalg.regNavn,
            MalmøteTjeneste.regNavn,
            Dialog.regNavn,
            regNavn.gettext.gettextCatalog,
            RedigerMøtemalDialog
        ]
    }

    constructor(private $mdDialog: angular.material.IDialogService,
                private $scope: IScope,
                private $window: IWindowService,
                private malmøteRes: MalmøteRessurs,
                private tidssonevalg: Tidssonevalg,
                private malmøteTjeneste: MalmøteTjeneste,
                private dialog: Dialog,
                private gettextCatalog: gettextCatalog) {
        //sørger for å legge til klasse på body slik at ajs overlay/dialog etc kan plasseres over tilsvarende for ng2
        //dette er viktig siden rediger-møtemaldialogen vises samtidig som nytt-møte dialogen (ng2)
        this.$window.document.body.classList.add('wm-rediger-moetemal-dialog')
    }

    gruppe: l.EnkelEllerGruppeModellEller; //settes via locals
    forespurtTrinn: RedigerMøtemalTrinn; //settes via locals

    moetemalModell: MøtemalSkjemaModell;
    tidssone: string;

    alleTrinn = RedigerMøtemalTrinn;
    trinn: RedigerMøtemalTrinn = RedigerMøtemalTrinn.moetedetaljer;
    lagrer = false;

    nesteTrinn() {
        this.trinn++;
    }

    forrigeTrinn() {
        this.trinn--;
    }

    varighetEndret(varighet: number) {
        this.moetemalModell.beregnSluttdato();
    }

    lagre(skjema) {
        if (!skjema.$valid) return;
        this.lagrer = true
        this.visBekreftLagreMelding()
            .then(() => this.malmøteRes.oppdater(this.moetemalModell.somSpesifikasjon()).$promise)
            .then(mal => this.$mdDialog.hide(mal))
            .finally(() => this.lagrer = false);
    }

    avbryt() {
        this.$mdDialog.cancel();
    }

    $onInit() {
        if (!_.isNil(this.forespurtTrinn)) this.trinn = this.forespurtTrinn;
        this.tidssone = this.tidssonevalg.aktivTidssoneAbbr();
        this.lyttTilSaksvarighetEndret();

        this.malmøteTjeneste.møtemalSkjemaModell(this.gruppe.id)
            .then(modell => this.moetemalModell = modell);
    }

    $onDestroy(): void {
        this.$window.document.body.classList.remove('wm-rediger-moetemal-dialog')
    }

    //hjelpemetoder

    private lyttTilSaksvarighetEndret() {
        this.$scope.$on(MalsakskjemaKontroller.eventMalsaksskjemaVarighetEndret, (e, nyVarighet) => {
            this.moetemalModell.beregnSluttdato();
        });
    }

    private visBekreftLagreMelding() {
        let meldingskropp = '<p>' +
            ///møtemal bekreft lagring dialog - linje 1/2
            this.gettextCatalog.getString('Du lagrer nå møtemalen for {{gruppe}} i {{organisasjon}}.', {gruppe: this.gruppe.tittel, organisasjon: this.gruppe.organisasjonsnavn}) +
            '</p><p>' +
            ///møtemal bekreft lagring dialog - linje 2/2
            this.gettextCatalog.getString('Endringer du har gjort vil ha effekt for <span class="std-fet">nye møter</span> som opprettes i denne gruppen. Du kan når som helst redigere denne malen på nytt.') +
            '</p>';
        return this.dialog.confirm(
            this.gettextCatalog.getString('Vil du lagre møtemalen?'),
            meldingskropp,
            this.gettextCatalog.getString('Lagre'),
            this.gettextCatalog.getString('Avbryt'))
    }
}

export enum RedigerMøtemalTrinn {
    moetedetaljer, saker, deltakere, publisering
}

/** Eksponerer RedigerMøtemalDialog som tjeneste for enklere bruk i ng2-kode */
export class RedigerMøtemalDialogTjeneste {
    static regNavn = 'RedigerMøtemalDialogTjeneste';

    static registrerTjeneste(angular: IModule) {
        angular.service(RedigerMøtemalDialogTjeneste.regNavn, [regNavn.md.$mdDialog, RedigerMøtemalDialogTjeneste]);
    }

    constructor(private $mdDialog: angular.material.IDialogService) {
    }

    visRedigerMøtemalDialog(gruppe: l.EnkelEllerGruppeModellEller): IPromise<l.MalmøteModell> {
        return RedigerMøtemalDialog.visRedigerMøtemalDialog(gruppe, this.$mdDialog);
    }

    visRedigerMøtemalDialogMedForespurtTrinn(gruppe: l.EnkelEllerGruppeModellEller, forespurtTrinn: RedigerMøtemalTrinn): IPromise<l.MalmøteModell> {
        return RedigerMøtemalDialog.visRedigerMøtemalDialogMedForepurtTrinn(gruppe, forespurtTrinn, this.$mdDialog);
    }
}
